import React, {useEffect, useState, useContext} from "react";
import Pagination from 'react-js-pagination';
import styled from 'styled-components';
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
//import ListItem from "../Component/ListItem.jsx";
import instance from "../../axios_interceptor.js";
import Header from "../Component/Header";
import AdminHeader from "../Component/AdminHeader.jsx";
// import AdminFooter from "../Component/AdminFooter.jsx";
import Footer from "../Component/Footer.jsx";
import SubMenu from "../Component/SubMenu";
import { ArgContext } from "../../Context/ArgProvider";  

// import mainBg from "../../assets/img/bg-busuness-01.jpg";
import mainBg from "../../assets/img/bg-company-02.jpg";



function ComHisPrivList() {
    // 화면 이동을 위한 네비게이터 설정
	const navigate = useNavigate();
    const { argInfo } = useContext(ArgContext);  // ArgContext 사용
    const isAdmin = argInfo?.role === 'admin';   // admin 여부 확인
    
    // 페이징 관련 변수
    const [page, setPage] = useState(1);
    const [items, setItems] = useState(10);
    const [totCnt, setTotCnt] = useState(0);
    const [pageRangeDisplayed, setPageRangeDisplayed] = useState(10);

    // 검색 조건
    const [yearList, setYearList] = useState([]);
    const [year, setYear] = useState();
    const [month, setMonth] = useState();
    const [taskContent, setTaskContent] = useState();

    // 연혁 리스트
    const [comYearList, setComYearList] = useState([]);
    
    // 월 조회
    useEffect(() => {
        axios.post("/selectYear")
        .then((response) => {
            console.log(response.data.rtnData)
            setYearList(response.data.rtnData);
        })
        .catch((error) => {
        // 예외 처리
        })
    }, []) 

    // 회사 연혁 조회하기
    const fn_selectAdminYearList = () => {
        const response = instance.post("/admin/selectAdminYearList"
            , { startPageNum : page, rnum : items, year : year, month : month, taskContent : taskContent}
            , {headers: {"Content-Type": "application/json"}});
        response.then((res) => {
            if(res.data.rtnCd=="SUCCESS") {
                setComYearList(res.data.rtnData);
                setTotCnt(res.data.rtnTotCnt);
                console.log(res.data);
            } else if(res.data.rtnCd=="EXPIRE") {
                if(window.confirm("로그인 세션이 만료되었습니다.")) navigate("/adminLogin");
            } else {
                alert("관리자에게 문의바랍니다.");
            }
        });
    }

    //페이징 화면 너비에 따라 pageRange 조절
    useEffect(() => {
        function updatePageRange() {
          const width = window.innerWidth;
          if (width < 768) {
            setPageRangeDisplayed(5); // 모바일
          } else {
            setPageRangeDisplayed(10); // 데스크탑
          }
        }
    
        updatePageRange(); // 최초 실행
        window.addEventListener('resize', updatePageRange); // 리사이즈 감지
    
        return () => {
          window.removeEventListener('resize', updatePageRange);
        };
      }, []);

    // 페이지 변경 이벤트
    const handlePageChange = (page) => { 
        setPage(page); 
    }

    // 현재 페이지 변경 되면 다시 재조회
    useEffect(() => {
        fn_selectAdminYearList();
    }, [page]);

    // 등록
    const fn_insert = () => {
        navigate("/comHisPrivWrite", {
            state: {
                gubun: "insert"
            }
        });
    }

    const handleYearChange = (e) => {
        setYear(e.target.value);
    }

    const handleMonthChange = (e) => {
        setMonth(e.target.value);
    }

    const handleContentChange = (e) => {
        setTaskContent(e.target.value);
    }

    
    

    return (<>
        
        <main className="page-wrapper">
        {isAdmin ? <AdminHeader /> : <Header />}  {/* 조건부 렌더링으로 변경 */}

            {/* <!-- 메인 미이지 + 슬로건 --> */}
			<section className="sub-bannerWrap comOverview-banner" style={{backgroundImage: `url(`+mainBg+`)`}} >
                    <div className="textBox">
                        <h2>회사연혁 리스트</h2>
                        <p>WIPIA는 끊임없는 도전을 통해 미래가치를 창출합니다.</p>
                    </div>
                    <SubMenu />
            </section>
			
            {/* 회사연혁 목록 */}
            <section className="container-auto sec-my comHis-list-wrap">
                <h3 className="sub-title">회사연혁 목록</h3>
                <div className="search-list">
                    <select onChange={handleYearChange} value={year}>
                        <option value="">전체</option>
                        {yearList.map((year)=> {
                            return <option value={year}>{year}</option>
                        })}
                    </select>
                    <span className="txt">년</span>
                    <select onChange={handleMonthChange} value={month}>
                        <option value="">전체</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                        <option value="6">6</option>
                        <option value="7">7</option>
                        <option value="8">8</option>
                        <option value="9">9</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                    </select>
                    <span className="txt">월</span>
                    <div className="search-box">
                        <input type="text"  placeholder="프로젝트 명을 검색해주세요." onChange={handleContentChange} value={taskContent}/>
                    </div>
                    <div className="btnWrap">
                        <button type="button" className="search-btn" onClick={fn_selectAdminYearList}>검색</button>
                        <button type="button" className="search-btn" onClick={()=>fn_insert()} >등록</button>
                    </div>
                </div>
                
                <div className="tableWrap">
                    <table>
                        <thead>
                            <tr className="text-center">
                                <th>년</th>
                                <th>월</th>
                                <th>프로젝트 명</th>
                            </tr>
                        </thead>
                        <tbody>
                            {comYearList.map((comYear) => {
                                return <ListRow data = {comYear}/>
                            })} 

                        </tbody>
                    </table>
                </div>
                <Pagination
                    // 현재 보고있는 페이지 
                    activePage={page}
                    // 한페이지에 출력할 아이템수
                    itemsCountPerPage={items}
                    // 총 아이템수
                    totalItemsCount={totCnt}
                    // 표시할 페이지수
                    pageRangeDisplayed={pageRangeDisplayed}
                    // 함수
                    onChange={handlePageChange}>
                </Pagination>
            
                {/* <div className="btnWrap">
                    <button type="button" className="write-btn" onClick={()=>fn_insert()} >등록</button>
                </div> */}
            </section>


		</main>
        <Footer />
        </>
    )
}

function ListRow(props) {
    const navigate = useNavigate();
    
    // 수정
    const fn_update = (data) => {
        navigate("/comHisPrivWrite", {
            state: {
                  gubun: "update"
                , data: data
            }
        });
    }

    return (<>
        <tr key={props.data.taskNo} onClick={() => fn_update(props.data)}>
			{/* <td className="text-center">{props.data.taskNo}</td> */}
			<td>{props.data.year}</td>
			<td>{props.data.month}</td>
			<td>{props.data.taskContent}</td>
		</tr>
    
    </>);
}
export default ComHisPrivList;